import { Tabs } from "antd";
import { showError } from "common/ToastNotifications";
import { BasicFormBuilder, LoadingOverlay, NotFoundError, ProhibitedArea } from "components";
import AppPaths from "constants/appPaths";
import Annotations from "containers/Annotations";
import Comments from "containers/Comments";
import { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import actions from "store/actions";

class DataObjectUUID extends Component {
    constructor(props) {
        super(props);
        this.state = {
            fetchingPermission: true,
            fetchingRecord: true,
            fetchingCommentsPermission: true,
            busy: false,
            busyMessage: "Please wait...",
        };
    }

    componentWillMount() {
        this.props.getDataObjectPermission();
        this.props.getDataObjectByUUID(this.props.dataObjectId);
        this.props.getCommentsPermission();
    }

    componentDidMount() {}

    componentWillReceiveProps(nextProps) {
        // Support older lifecycle - not ideal but keeps parity
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        this.onGetDataObjectPermissionResultChanged(prevProps);
        this.onGetDataObjectByUUIDResultChanged(prevProps);
        this.onUpdateDataObjectResultChanged(prevProps);
        this.onGetCommentsPermissionResultChanged(prevProps);
    }

    onGetDataObjectPermissionResultChanged = (prevProps) => {
        if (this.props.getDataObjectPermissionResult && this.props.getDataObjectPermissionResult !== prevProps.getDataObjectPermissionResult) {
            if (!this.props.getDataObjectPermissionResult.success || !this.props.dataObjectPermission || !this.props.dataObjectPermission.canView) {
                this.setState({
                    permissionDenied: true,
                });
            }
            this.setState({
                fetchingPermission: false,
            });
        }
    };

    onGetCommentsPermissionResultChanged = (prevProps) => {
        if (this.props.getCommentsPermissionResult && this.props.getCommentsPermissionResult !== prevProps.getCommentsPermissionResult) {
            if (!this.props.getCommentsPermissionResult.success) {
                showError("Could not retrieve comments permissions.");
            }
            this.setState({
                fetchingCommentsPermission: false,
            });
        }
    };

    onGetDataObjectByUUIDResultChanged = (prevProps) => {
        if (this.props.getDataObjectByUUIDResult && this.props.getDataObjectByUUIDResult !== prevProps.getDataObjectByUUIDResult) {
            if (!this.props.getDataObjectByUUIDResult.success) {
                if (this.props.getDataObjectByUUIDResult.code === "PERMISSION_DENIED") {
                    this.setState({
                        permissionDenied: true,
                    });
                } else {
                    showError("Unable to retrieve dataset record.");
                }
            }
            this.setState({
                fetchingRecord: false,
            });
        }
    };

    onUpdateDataObjectResultChanged = (prevProps) => {
        if (this.props.updateDataObjectResult && this.props.updateDataObjectResult !== prevProps.updateDataObjectResult) {
            if (!this.props.updateDataObjectResult.success) {
                if (this.props.updateDataObjectResult.code === "PERMISSION_DENIED") {
                    this.setState({
                        busy: false,
                    });
                    showError("Unable to update dataset record. Permission Denied.");
                } else {
                    this.setState({
                        busy: false,
                    });
                    showError("Unable to update dataset record.");
                }
            } else {
                this.setState({
                    busy: false,
                    fetchingRecord: true,
                });
                this.props.getDataObjectByUUID(this.props.dataObjectId);
            }
        }
    };

    updateDataObject = (dataObjectId, dataObject) => {
        this.setState({
            busy: true,
            busyMessage: "Updating dataset record...",
        });
        this.props.updateDataObject(
            this.props.dataObjectByUUIDResult.dataObject.businessAreaId,
            this.props.dataObjectByUUIDResult.dataObject.schemaId,
            this.props.dataObjectByUUIDResult.dataObject.dataSetId,
            dataObjectId,
            dataObject,
        );
    };

    goToHome = () => {
        this.props.history.push(AppPaths.TENANT_HOME.replace(":tenant", this.props.tenant.toLowerCase()));
    };

    isBusy = () => {
        let isBusy = this.state.fetchingPermission || this.state.fetchingRecord || this.state.busy;
        return isBusy;
    };

    getNotFoundError = () => {
        if (this.props.getDataObjectByUUIDResult.success && !this.props.dataObjectByUUIDResult) {
            return {
                title: "Dataset record not found.",
                description: "The dataset record you are looking for does not exist.",
            };
        }
        return null;
    };

    render() {
        if (this.state.permissionDenied) {
            return <ProhibitedArea></ProhibitedArea>;
        }
        if (this.isBusy()) {
            return <LoadingOverlay busy={this.isBusy()} spinner message={this.state.busyMessage || "Please wait..."}></LoadingOverlay>;
        }
        let notFoundError = this.getNotFoundError();
        if (notFoundError) {
            return <NotFoundError title={notFoundError.title} description={notFoundError.description}></NotFoundError>;
        }

        this._forceOpenTab = null;
        try {
            const params = new URLSearchParams(this.props.location ? this.props.location.search : window.location.search);
            if (params.get("dataobject_annotation") === "true" && this.props.userCommentsPermission?.canView) {
                this._forceOpenTab = "annotations";
            } else if (params.get("dataobject_comment") === "true" && this.props.userCommentsPermission?.canView) {
                this._forceOpenTab = "comments";
            }
        } catch (e) {}

        const defaultActiveKey = this._forceOpenTab || "details";

        return (
            <div className="page-container">
                <Tabs defaultActiveKey={defaultActiveKey}>
                    <Tabs.TabPane tab="Details" key="details">
                        <BasicFormBuilder
                            key={`${this.props.dataObjectId}_${this.props.dataObjectByUUIDResult.dataObject.version}`}
                            showHeader={false}
                            formDataObject={this.props.dataObjectByUUIDResult.dataObject}
                            schemaFields={(this.props.dataObjectByUUIDResult.schemaModel && this.props.dataObjectByUUIDResult.schemaModel.fields) || []}
                            onCreate={() => {}}
                            onUpdate={this.updateDataObject}
                            onCancel={this.goToHome}
                            readOnly={!this.props.dataObjectPermission.canEdit}
                            fromhyperlink={true}
                            showRevealButton={true}
                        />
                    </Tabs.TabPane>

                    {this.props.userCommentsPermission?.canView && (
                        <Tabs.TabPane tab="Comments" key="comments">
                            <Comments key={this.props.dataObjectId} recordId={this.props.dataObjectId} permission={this.props.userCommentsPermission} recordType="dataobject" />
                        </Tabs.TabPane>
                    )}

                    {this.props.userCommentsPermission?.canView && (
                        <Tabs.TabPane tab="Annotations" key="annotations">
                            <Annotations
                                key={`${this.props.dataObjectId}-annotations`}
                                recordId={this.props.dataObjectId}
                                recordType="dataRecord"
                                permission={this.props.userCommentsPermission}
                                fields={this.props.dataObjectByUUIDResult?.schemaModel?.fields || []}
                                businessAreaId={this.props.dataObjectByUUIDResult?.dataObject?.businessAreaId}
                            />
                        </Tabs.TabPane>
                    )}
                </Tabs>
            </div>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        getDataObjectPermissionResult: state.dataObjects.getDataObjectPermissionResult,
        dataObjectPermission: state.dataObjects.dataObjectPermission,
        getDataObjectByUUIDResult: state.dataObjects.getDataObjectByUUIDResult,
        dataObjectByUUIDResult: state.dataObjects.dataObjectByUUIDResult,
        updateDataObjectResult: state.dataObjects.updateDataObjectResult,
        getCommentsPermissionResult: state.comments.getCommentsPermissionResult,
        userCommentsPermission: state.comments.userCommentsPermission,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getDataObjectPermission: () => dispatch(actions.getDataObjectPermissionRequest()),
        getDataObjectByUUID: (dataObjectId) => dispatch(actions.getDataObjectByUUIDRequest(dataObjectId)),
        updateDataObject: (businessAreaId, schemaId, dataSetId, dataObjectId, dataObject) =>
            dispatch(actions.updateDataObjectRequest(businessAreaId, schemaId, dataSetId, dataObjectId, dataObject)),
        getCommentsPermission: () => dispatch(actions.getCommentsPermissionRequest()),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(DataObjectUUID));
